/**
 * Business Partners Page
 *
 * Displays all business partners (both persons and companies) using UniversalTable component
 * Route: /apps/business-partners/all
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UniversalTable } from '@/components/features/udc/UniversalTable';
import { Tag } from 'antd';

export const BusinessPartnersPage: React.FC = () => {
  const navigate = useNavigate();

  const handleRowClick = (record: any) => {
    // Navigate to business partner detail page when row is clicked
    navigate(`/apps/business-partners/${record.id}`);
  };

  return (
    <UniversalTable
      collection="bp"
      profile="goldenwings_default"
      title="Business Partners"
      searchPlaceholder="Search business partners..."
      onRowClick={handleRowClick}
      customRenderers={{
        // Custom renderer for BP type (show as tag)
        bp_type: (value) => {
          const color = value === 'PERSON' ? 'blue' : 'green';
          const label = value === 'PERSON' ? 'Person' : 'Company';
          return <Tag color={color}>{label}</Tag>;
        },
        // Custom renderer for customer flag
        is_customer: (value) => {
          return value ? <Tag color="success">Customer</Tag> : null;
        },
        // Custom renderer for supplier flag
        is_supplier: (value) => {
          return value ? <Tag color="processing">Supplier</Tag> : null;
        },
        // Custom renderer for prospect flag
        is_prospect: (value) => {
          return value ? <Tag color="warning">Prospect</Tag> : null;
        },
      }}
    />
  );
};
